import { GcloudIconUrl } from "@p0security/shared/integrations/constants";
import { GcloudComponents } from "@p0security/shared/integrations/resources/gcloud/components";
import { Typography } from "antd";
import { useCallback } from "react";
import { Link } from "react-router-dom";

import { Install, InstallProps } from "../Install/Install";
import { gcloudInstaller } from "./install";

const GcloudPreamble = (
  <>
    <Typography.Text strong>
      Recommended components by use case:
    </Typography.Text>
    <ul className="preamble-list">
      <li>
        <strong>Just-in-time access:</strong>{" "}
        <Link to="./iam-write-security-perimeter">Security Perimeter</Link>,
        then <Link to="./iam-write">IAM Management</Link>
      </li>
      <li>
        <strong>Inventory and Posture:</strong>{" "}
        <Link to="./iam-assessment">IAM Assessment</Link> or{" "}
        <Link to="./org-iam-assessment">Organization IAM Assessment</Link>, and
        optionally <Link to="./access-logs">Access Logging</Link>
      </li>
      <li>
        <strong>Custom notifiers:</strong>{" "}
        <Link to="./function-caller">Cloud Run Invocation</Link>
      </li>
    </ul>
  </>
);

export const Gcloud = (
  props: Pick<
    InstallProps<typeof GcloudComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(
    (use: string) =>
      use === "function-caller"
        ? "Cloud Run Service"
        : use === "wif-provider"
          ? "WIF provider"
          : "project",
    []
  );

  const identifier = useCallback(
    (use: string) => (use === "function-caller" ? "name" : "identifier"),
    []
  );

  return (
    <Install<typeof GcloudComponents>
      components={GcloudComponents}
      installer={gcloudInstaller}
      integration="gcloud"
      itemKind={itemKind}
      identifier={identifier}
      logo={GcloudIconUrl}
      preamble={GcloudPreamble}
      title={"Google Cloud"}
      {...props}
    />
  );
};
